import React from 'react';
import { Path, Svg } from 'react-native-svg';
import { useUnistyles } from 'react-native-unistyles';

import type { AppColors } from '@squire/ui';

interface MenuIconProps {
  size?: number;
  color?: keyof AppColors;
  strokeWidth?: number;
}

export const MenuIcon: React.FC<MenuIconProps> = ({
  size = 24,
  color = 'iconPrimary',
  strokeWidth,
}) => {
  const { theme: colors } = useUnistyles();

  return (
    <Svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24 5H0V3H24V5ZM24 13H0V11H24V13ZM0 21H24V19H0V21Z"
        fill={colors[color]}
        strokeWidth={strokeWidth}
      />
    </Svg>
  );
};
